import { childAgeText } from './formatTourists';
import { MAX_CHILD_AGE, MIN_CHILD_AGE } from './touristsRooms';
import type { ChildAgeOption } from '../model/types';

export const CHILD_AGE_OPTIONS: ChildAgeOption[] = Array.from(
  { length: MAX_CHILD_AGE - MIN_CHILD_AGE + 1 },
  (_, i): ChildAgeOption => ({ value: MIN_CHILD_AGE + i, label: childAgeText(MIN_CHILD_AGE + i) }),
);
